import axios from 'axios'
import { User } from 'firebase/auth'

import { FeedbackItems } from './types'

export async function fetchFeedbackItems(user: User): Promise<FeedbackItems> {
	const userToken = await user.getIdToken()
	const response = await axios.get(`${process.env.REACT_APP_API_URL}/feedback/items`, {
		headers: {
			Authorization: userToken,
		},
	})
	return response.data
}
